import React from "react";
import { SearchResultItemType, TabData } from "../../useSearch";
import styles from "./SearchTabContent.module.scss";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { NoResult, ResultItem } from "../../ResultItem/ResultItem";
import { Icon } from "@/components/Global/Icon/Icon";
import { LoaderCircle } from "@/components/Global/LoaderCircle/LoaderCircle";
import { customSanitize } from "@/utils/customSanitize";

interface SearchTabContentProps {
  tabData: TabData;
  labelledby: string;
  fetchMore: () => void;
  currentTab: number;
}

export const SearchTabContent = ({
  tabData,
  labelledby = "",
  fetchMore,
  currentTab,
}: SearchTabContentProps) => {
  const { loading } = useAppContext();
  const { isFullyLoaded, results } = tabData;
  const { getLabel, getIcon } = useGlobalContext();
  const kleineTipTopfData = results.filter(
    (x) => x.produkttyp == "Der kleine Tiptopf" && x.value_type === "Rezept",
  );
  const TipTopfData = results.filter(
    (x) => x.produkttyp === "Tiptopf" && x.value_type === "Rezept",
  );

  const ingredientsData = results.filter((x) => x.value_type === "Zutat");

  const otherData = results
    .filter(
      (x) =>
        kleineTipTopfData.includes(x) === false &&
        TipTopfData.includes(x) === false &&
        ingredientsData.includes(x) === false,
    )
    .filter((x) => x.value_type !== "Rezept" && x.value_type !== "Zutat");

  const ResultsList = ({
    recipes,
    title,
  }: {
    recipes: SearchResultItemType[];
    title?: string;
  }) => {
    return (
      <div className={styles["tiptopf-results"]}>
        {title && (
          <span
            className={styles["tiptopf-result-title"]}
            data-wplabel-id={title}
            dangerouslySetInnerHTML={{
              __html: customSanitize(getLabel(title)),
            }}
          />
        )}
        {recipes.map((result, i) => {
          return (
            <ResultItem
              key={`${result.value_id}-${i}`}
              cardType={
                result.produkttyp !== "Der kleine Tiptopf"
                  ? "tip_topf"
                  : "kleine_tip_topf"
              }
              // cardType="ingredient"
              result={result}
              index={i + 1}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div role={"tabpanel"} aria-labelledby={labelledby}>
      <div className={styles["results-wrapper"]}>
        <div className={"klien-tiptopf-results"}>
          {results.length === 0 && !loading && <NoResult />}
          {(currentTab === 0 || currentTab === 1) && (
            <>
              {kleineTipTopfData?.map?.((result, i) => {
                return (
                  <ResultItem
                    key={`${result.value_id}-${i}`}
                    result={result}
                    index={i + 1}
                  />
                );
              })}
              {kleineTipTopfData.length === 0 && TipTopfData?.length > 0 && (
                <div
                  className={`result-item ${styles["result-item"]} ${styles["no-result"]}`}
                  style={{ borderBottom: "none" }}
                >
                  <div className="text">
                    <span
                      className={styles["result-name"]}
                      dangerouslySetInnerHTML={{
                        __html: getLabel(
                          "search_no_results_in_current_platform",
                          "Deine Suche ergab keine Treffer.",
                        ),
                      }}
                    />
                  </div>
                </div>
              )}

              {TipTopfData && TipTopfData.length > 0 && (
                <ResultsList
                  recipes={TipTopfData}
                  title="tiptopf_result_title"
                />
              )}
              {ingredientsData && ingredientsData.length > 0 && (
                <ResultsList
                  recipes={ingredientsData}
                  title="ingredients_result_title"
                />
              )}
            </>
          )}
          {currentTab === 2 && results && results.length > 0 && (
            <>
              {results.map((result, i) => {
                return (
                  <ResultItem
                    key={`${result.value_id}-${i}`}
                    result={result}
                    index={i + 1}
                    cardType={
                      result.produkttyp === "Tiptopf" ||
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (result.produkttyp as any) === ""
                        ? "tip_topf"
                        : "kleine_tip_topf"
                    }
                  />
                );
              })}
            </>
          )}
          {(currentTab === 0 || currentTab === 3) &&
            otherData &&
            otherData.length > 0 && (
              <ResultsList
                recipes={otherData}
                {...(currentTab === 0 ? { title: "other_result_title" } : {})}
              />
            )}
        </div>

        {loading && <LoaderCircle />}
      </div>
      {!loading && !isFullyLoaded && results?.length > 0 && (
        <div className="is-flex is-justify-content-center mt-6">
          <button className={styles["load-more-btn"]} onClick={fetchMore}>
            {getLabel("search_load_more", "Mehr anzeigen")}
            <Icon src={getIcon("arrow-circle")} width={22} height={22} />
          </button>
        </div>
      )}
    </div>
  );
};
